(function () {
  function initVacuumSpec(section) {
    var sectionId = section.id.replace('vacuum-spec-', '');
    var swiperEl = section.querySelector('.vacuumSwiper-' + sectionId);
    if (swiperEl && typeof Swiper !== 'undefined') {
      new Swiper(swiperEl, {
        pagination: {
          el: section.querySelector('.vacuumSwiper-pagination-' + sectionId),
          clickable: true,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
      });
    }

    var scrollRegion = section.querySelector('.vacuum-spec-scroll[data-scroll-step]');
    if (scrollRegion) {
      var step = parseInt(scrollRegion.getAttribute('data-scroll-step'), 10) || 190;
      scrollRegion.addEventListener('keydown', function (event) {
        if (scrollRegion.scrollWidth <= scrollRegion.clientWidth) return;
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        scrollRegion.scrollBy({
          left: event.key === 'ArrowRight' ? step : -step,
          behavior: 'smooth',
        });
      });
    }

    setTimeout(function () {
      loadAreviews(section);
    }, 500);
  }

  function loadAreviews(section) {
    var zeroReviewText =
      (window.vacuumSpecStrings && window.vacuumSpecStrings.zeroReview) || '0 review';
    var params = new URLSearchParams();
    var productIds = [];

    section.querySelectorAll('.areviews_product_item').forEach(function (item) {
      var id = item.getAttribute('data-product-id');
      if (!id) return;
      productIds.push(String(id));
      params.append('ids[]', id);
    });

    productIds = [...new Set(productIds)];
    if (!productIds.length) return;

    params.append('collection_reviews', 'collection_reviews');

    fetch('/apps/aliexpress_reviews', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (r) {
        var hasReviewsProducts = Object.values(r)
          .filter(function (item) {
            return item.product_id;
          })
          .map(function (item) {
            return String(item.product_id);
          });
        var diffProducts = productIds.filter(function (x) {
          return !hasReviewsProducts.includes(x);
        });

        section.querySelectorAll('[data-product-id]').forEach(function (item) {
          if (!diffProducts.includes(item.getAttribute('data-product-id'))) return;
          var placeholder = document.createElement('div');
          placeholder.className = 'areviews-rating-placeholder';
          placeholder.innerHTML =
            '<div class="areviews_rating" style="margin-top: 5px;"><i class="far fa-star" aria-hidden="true"></i><i class="far fa-star" aria-hidden="true"></i><i class="far fa-star" aria-hidden="true"></i><i class="far fa-star" aria-hidden="true"></i><i class="far fa-star" aria-hidden="true"></i><span>' +
            zeroReviewText +
            '</span></div>';
          item.appendChild(placeholder);
        });
      })
      .catch(function () {
        /* Areviews optional */
      });
  }

  function initAll() {
    document.querySelectorAll('.vacuum_cleaner_specification[id^="vacuum-spec-"]').forEach(initVacuumSpec);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.vacuum_cleaner_specification[id^="vacuum-spec-"]').forEach(initVacuumSpec);
  });
})();
